import * as Yup from 'yup';
import { graphql } from '@/gql/graphql';

export const BadgeEditFormFragment = graphql(/* GraphQL */ `
  fragment BadgeEditForm on badge {
    id
    title
    color
    attribute_preview_id
    badge_attributes(order_by: { order: asc }) {
      id
      title
      options_csv
      attribute_type
      is_required
      order
    }
  }
`);

export type BadgeEditFormValues = {
  id?: string;
  title: string;
  color: string;
  attribute_preview_id?: string | null;
  badge_attributes?: BadgeEditFormAttribute[];
};

type BadgeEditFormAttribute = {
  id: string;
  title: string;
  options_csv?: string | null;
  attribute_type: ReturnType<
    typeof graphql.scalar<'badge_attribute_type_enum'>
  >;
  is_required?: boolean;
  order?: number | null;
};

const badgeEditAttributeValidator: Yup.ObjectSchema<BadgeEditFormAttribute> =
  Yup.object({
    id: Yup.string().required(),
    title: Yup.string().trim().required('Required'),
    options_csv: Yup.string().nullable().optional(),
    attribute_type: Yup.mixed<BadgeEditFormAttribute['attribute_type']>()
      .oneOf(['numeric', 'text'])
      .required(),
    is_required: Yup.boolean().optional(),
    order: Yup.number().nullable().optional(),
  });

export const badgeEditValidator: Yup.ObjectSchema<BadgeEditFormValues> =
  Yup.object({
    id: Yup.string().optional(),
    title: Yup.string().trim().required('Required'),
    color: Yup.string().required('Required'),
    attribute_preview_id: Yup.string().nullable().optional(),
    badge_attributes: Yup.array()
      .of(badgeEditAttributeValidator.required())
      .optional(),
  });

export const attributeTypeLabel = {
  text: 'Text',
  numeric: 'Number',
};
